import { render, staticRenderFns } from "./AddBook.vue?vue&type=template&id=67610c88&scoped=true&"
import script from "./AddBook.vue?vue&type=script&lang=js&"
export * from "./AddBook.vue?vue&type=script&lang=js&"
import style0 from "./AddBook.vue?vue&type=style&index=0&id=67610c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67610c88",
  null
  
)

export default component.exports